<template>
    <span 
  v-show="isShow" 
  class="inline-block rounded-full animate-spin ml-1"
  :class="customClass"
  :style="{
            border: `solid ${color}`,
            borderTopColor: 'transparent',
        }"
></span>
</template>

<script>
export default {
    name: "UiSmallLoader",
    props: {
        isShow: {
            type: Boolean,
            required: true,
            default: false,
        },
        customClass: {
            type: [String, Array, Object],
            default: null,
        },
        light: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        color() {
            return this.light ? '#007f9f' : 'white'
        }
    }
}
</script>